import React, { Component, PureComponent } from 'react'
import { Map, List, fromJS } from 'immutable'
import { connect } from 'react-redux'
import { loadReferenceData } from '../actions'
import { Loader, Message, Dropdown, Table } from 'semantic-ui-react'

const refId = 'tasks'

class Tasks extends Component {
  componentDidMount() {
    let { loadReferenceData } = this.props

    loadReferenceData(refId, {
      source: 'task_type',
    })
  }

  render() {
    let {
      name,
      value,
      referenceConfig,
      referenceData,
      referenceLoading,
      referenceError,
      placeholder = 'Valitse',
      onChange,
      disabled = false,
    } = this.props

    let loading = referenceLoading.get(refId, true)
    let error = referenceError.get(refId, false)
    let data = referenceData.get(refId, List())

    if (!List.isList(value)) value = List()

    value = value.filter(v => Map.isMap(v))

    let options = data.toJS().map(item => ({ key: item.id, text: item.text || item.id, value: item.id }))

    return (
      <div className="form-input form-input--tasks taskeditor-wrapper">
        {error ? <Message content={error} negative visible /> : null}
        <div className="taskeditor">
          <Table size="small" compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell content="Tehtävätyyppi" />
                <Table.HeaderCell style={{ width: 100 }} content="Määrä" />
                <Table.HeaderCell style={{ width: 100 }} content=" " />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {value.map((item, key) => {
                if (!Map.isMap(item)) return null

                let taskTypeId = item.get('task_type_id')
                let count = item.get('count', 1)
                let taskName = (options.find(({ key }) => key === taskTypeId) || {}).text || taskTypeId

                return (
                  <Table.Row key={key}>
                    <Table.Cell>{taskName}</Table.Cell>
                    <Table.Cell>
                      <input
                        type="number"
                        value={count}
                        onChange={e =>
                          onChange({
                            name,
                            value: value.setIn([key, 'count'], e.target.value < 1 ? 1 : parseInt(e.target.value)),
                          })
                        }
                      />
                    </Table.Cell>
                    <Table.Cell>
                      {!disabled ? (
                        <button
                          className="button-plain button-plain--red"
                          onClick={e => e.preventDefault() & onChange({ name, value: value.remove(key) })}>
                          poista
                        </button>
                      ) : null}
                    </Table.Cell>
                  </Table.Row>
                )
              })}
            </Table.Body>
          </Table>
          <div className="taskeditor-actions">
            <Dropdown
              options={options}
              text="+ Lisää tehtävätyyppi"
              noResultsMessage="Tehtävätyyppejä ei löytynyt"
              search
              fluid
              selection
              selectOnBlur={false}
              selectOnNavigation={false}
              loading={loading}
              disabled={disabled}
              compact
              closeOnChange
              defaultUpward
              onChange={(e, { value: task_type_id } = {}) =>
                onChange({ name, value: value.push(Map({ task_type_id, count: 1 })) })
              }
            />
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    referenceData: state.formData.get('_referenceData', Map()),
    referenceLoading: state.formData.get('_referenceLoading', Map()),
    referenceError: state.formData.get('_referenceError', Map()),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    loadReferenceData: (id, options) => dispatch(loadReferenceData(id, options)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tasks)
